import { configureStore } from '@reduxjs/toolkit'
import authReducer from './auth/authSlice'
import navReducer from './nav/navSlice'
import filterReducer from './ui/filterSlice'

export const store = configureStore({
    reducer: {
        auth: authReducer,
        nav: navReducer,
        filter: filterReducer,
    }
})


